import React from 'react';
import PropTypes from 'prop-types';

import {
  NavButton,
  HardwareButton,
} from 'components/buttons';

import styles from './HardwareButtonWrapper.scss';

const HardwareButtonWrapper = ({ config }) => {
  const defaultConfig = {
    left: {},
    center: {},
    right: {}
  };

  const getConfig = () => Object.assign({}, defaultConfig, config);

  const cancelTouchEnd = (e) => {
    e.preventDefault();
    e.target.click();
  };

  const conf = getConfig();

  return (
    <div className={styles.buttonWrapper} onTouchEnd={cancelTouchEnd}>
      {conf.left.destination !== undefined ?
        <NavButton position="left" destination={conf.left.destination} />
      :
        <HardwareButton position="left" onClick={conf.left.onClick} />
      }
      {conf.center.destination !== undefined ?
        <NavButton position="center" destination={conf.center.destination} />
        :
        <HardwareButton position="center" onClick={conf.center.onClick} />
      }
      {conf.right.destination !== undefined ?
        <NavButton position="right" destination={conf.right.destination} />
        :
        <HardwareButton position="right" onClick={conf.right.onClick} />
      }
    </div>
  );
};

HardwareButtonWrapper.propTypes = {
  config: PropTypes.shape({
    left: PropTypes.object,
    center: PropTypes.object,
    right: PropTypes.object
  }).isRequired
};

export default HardwareButtonWrapper;



// WEBPACK FOOTER //
// ./src/containers/HardwareButtonWrapper/HardwareButtonWrapper.js